import { Button } from '@/components/ui/Button';

type RentPriceInfoStepProps = {
  onNext: () => void;
};

const RentPriceInfoStep = ({ onNext }: RentPriceInfoStepProps) => {
  return (
    <>
      <h1>Vorabprüfung Mietangebot</h1>
      <p>
        Es handelt sich um einen Service für Kund:innen des Jobcenter Dortmund bzw. für Personen, die in das Stadtgebiet Dortmund umziehen
        möchten und auf Leistungen nach dem Zweiten Sozialgesetzbuch (SGB II) angewiesen sind.
      </p>
      <p>
        Dieser Service soll als Anhaltspunkt dienen. Jeder Antrag wird individuell geprüft (Einzelfallprüfung) und kann anders beschieden
        werden.
      </p>
      <Button onClick={() => onNext()} className="font-bold">
        Vorabprüfung starten
      </Button>
    </>
  );
};

export default RentPriceInfoStep;
